__turbopack_context__.v({
  "dMenuItem": "desktop-menu-module-scss-module__fJzKGa__dMenuItem",
  "dMenuItemActive": "desktop-menu-module-scss-module__fJzKGa__dMenuItemActive",
  "dMenuItemWrapper": "desktop-menu-module-scss-module__fJzKGa__dMenuItemWrapper",
});
